import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';

export const BetaNotificationBar: React.FC = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(true);

  // Don't render if dismissed
  if (!isVisible) return null;

  return (
    <div className="bg-blue-600 text-white px-4 py-3 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto relative">
        <div className="flex items-center justify-center gap-2">
          <span className="text-base">👋🏽</span>
          <p className="text-sm font-medium text-center">
            {t('beta.notificationMessage', 'Thanks for joining the beta. Write me on the Chat if any bugs 👇🏽')}
          </p>
        </div>
        
        <button
          onClick={() => setIsVisible(false)}
          className="absolute right-0 top-1/2 -translate-y-1/2 p-1 hover:bg-white/20 rounded-full transition-colors"
          aria-label={t('common.close', 'Close')}
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}; 